import React from 'react';
import './libro_bl_gri.css';
import { useTranslation } from 'react-i18next';
import LA_vector from '../../../../assets/imgs/home_cinco/LA_vector.png'
import libro_blanco from '../../../../assets/img/portada_libro_blanco_ricardo_salinas.png'


const Libro_bl_gri = () => {

    const [t, i18n] = useTranslation("home");
    const liga_lang2='/'+i18n.language+"/librolibertad";

    return (
        <div class="H5_LB_contenedor">
            <div class="H5_LB_contenedor_escritorio">
                <div class="H5_LB_img">
                    <img class="H5_LB_libro" src={libro_blanco}/>
                </div>
                <div class="H5_LB_txt">
                    <h1 dangerouslySetInnerHTML={{__html:t('slider.third-first')}}>
                        
                    </h1>
                    <img src={LA_vector} alt="Imagen Vector" class="LB_linea" />
                    <p dangerouslySetInnerHTML={{__html:t('slider.third-second')}}>
                                  
                    </p>
                    <a href={liga_lang2} class="H5_LB_txt-button">{(t('slider.more'))}</a>
                </div>
            </div>
            <div class='H5_LB_contenedor_movil'>
                    <div class="H5_LB_movil_titulo" dangerouslySetInnerHTML={{__html:t('slider.third-third')}}>
                       
                    </div>
                    <div class="H5_LB_movil_txt" dangerouslySetInnerHTML={{__html:t('slider.third-fourth')}}>
                        
                    </div>
                    <div class="H5_LB_movil_img">
                        <img src={libro_blanco} />
                        <a href={liga_lang2} class="H5_LB_movil_img-button">{(t('slider.more'))}</a>
                    </div>
                </div>
        </div>
    )
}

export default Libro_bl_gri
